import React from 'react';
import './SuccessModal.css';
import { Modal, ModalHeader } from 'react-bootstrap';
import iosLogo from '../../assets/ioslogo.svg'
import androidLogo from '../../assets/playstorelogo.png';
import { playStoreLink, appStoreLink } from '../../constant';

function SuccessModal({
  showSuccessModal, setShowSuccessModal, responseMessage, candidateId
}) {

  let dynamicSubText = "You have been registered for the Retail Samarth Program. To Continue, download our app from the links below";
  let dynamicHeadingText = "CONGRATULATIONS!";

  if (responseMessage && responseMessage?.toLowerCase().includes('mobile')) {
    dynamicSubText = `Entered Phone Number / Email Id already exists in our database with the Candidate id - ${candidateId}. Please login with mobile number and OTP in our Retail Samarth app. Download the app using the below links.`;
    dynamicHeadingText = "ALERT!"
  }

  if (responseMessage && responseMessage?.toLowerCase().includes('mail')) {
    dynamicSubText = `Entered Phone Number / Email Id already exists in our database with the Candidate id - ${candidateId}. Please login with mobile number and OTP in our Retail Samarth app. Download the app using the below links.`;
    dynamicHeadingText = "ALERT!";
  }

  if (responseMessage && responseMessage?.toLowerCase().includes('congratulation')) {
    dynamicSubText = `You have been registered for the Retail Samarth Program with ${candidateId}. To Continue, download our app from the links below`;
    dynamicHeadingText = "CONGRATULATIONS!";
  }



  return (
    <Modal
      size='md'
      aria-labelledby="contained-modal-title-vcenter"
      centered show={showSuccessModal}
      onHide={() => {
        setShowSuccessModal(false);
      }}
    >
      <ModalHeader>
        <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => setShowSuccessModal(false)}>
          <span aria-hidden="true">&times;</span>
        </button>
      </ModalHeader>
      <div className='successModalContainer'>
        <p className='mainText'>{dynamicHeadingText}</p>
        <p className='subText'>{dynamicSubText}</p>
        <div className='imageContainer'>
          <a href={appStoreLink} rel='noreferrer' target='_blank'>
            <img className='logoImage' src={iosLogo} alt='iOS logo' />
          </a>
          <a href={playStoreLink} rel='noreferrer' target='_blank'>
            <img className='logoImage' src={androidLogo} alt='iOS logo' />
          </a>
        </div>
      </div>
    </Modal>
  )
}

export default SuccessModal;